<template>
	<div class="page_all">
		<div class="return_link">
			<router-link to="/disasterType">＞ マイタイムライン</router-link>
		</div>
		<div class="page_header">
      <div class="header_title">
        <div v-if="changeFlg" class="title">災害種別の編集</div>
        <div v-else class="title">災害種別の追加</div>
        <div class="area_radios_div">
          <div class="area_radio_div">
            <input class="area_radio_input" id="ja_radio" type="radio" value=1 v-model="languageRadio">
            <label class="area_radio_label" for="ja_radio">
                日本語
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="en_radio" type="radio" value=2 v-model="languageRadio">
            <label class="area_radio_label" for="en_radio">
              英語
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="kan_radio" type="radio" value=3 v-model="languageRadio">
            <label class="area_radio_label" for="kan_radio">
              韓国語
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="chu_han_radio" type="radio" value=4 v-model="languageRadio">
            <label class="area_radio_label" for="chu_han_radio">
              中国語(繁体字)
            </label>
          </div>
          <div class="area_radio_div">
            <input class="area_radio_input" id="chu_kan_radio" type="radio" value=5 v-model="languageRadio">
            <label class="area_radio_label" for="chu_kan_radio">
              中国語(簡体字)
            </label>
          </div>
        </div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
			<div>
        <button :disabled="$v.disasterName.$invalid || $v.description.$invalid || this.updating" v-if="changeFlg" class="btn_general" v-on:click="disasterTypeUpdate()">更新</button>
        <button :disabled="$v.disasterName.$invalid || $v.description.$invalid || this.updating" v-else class="btn_general" v-on:click="disasterTypeAdd()">追加</button>
			</div>
		</div>
		<div class="page_main">
			<table class="tbl_main">
				<thead>
					<tr>
						<th class="th_regist" colspan="2">登録内容</th>
					</tr>
				</thead>
        <!-- ja -->
				<tbody v-if="languageRadio == 1 || languageRadio == ''">
					<tr>
						<td class="td_content_top">
							<div class="index_name">種別</div>
							<div>
								<input v-model.trim="$v.disasterName.$model" type="text" class="input_text"/>
							</div>
              <div class="message">
                <div v-if="$v.disasterName.$dirty">
                  <div class="error" v-if="!$v.disasterName.required">種別は必須入力です。</div>
                  <div class="error" v-if="!$v.disasterName.maxLength">種別は{{ $v.disasterName.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
						</td>
						<td class="td_mark">
              <div class="mark_outer">
                <div class="mark_inner" id="color_box" v-bind:style="{backgroundColor: 'rgb('+this.markColor+')'}">
                  <a v-if="changeFlg" @click="openModalColor()">{{ disasterName }}</a>
                  <a v-else @click="openModalColor()">マーク</a>
                </div>
              </div>
            </td>
					</tr>
					<tr>
						<td class="td_content_bottom">
							<div class="index_name">説明</div>
							<div>
								<input v-model.trim="$v.description.$model" type="text" class="input_text"/>
							</div>
              <div class="message">
                <div v-if="$v.description.$dirty">
                  <div class="error" v-if="!$v.description.maxLength">説明は{{ $v.description.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
						</td>
						<td class="td_mark"></td>
					</tr>
				</tbody>
        <!-- english -->
				<tbody v-if="languageRadio == 2">
					<tr>
						<td class="td_content_top">
							<div class="index_name">種別(英語)</div>
							<div>
								<input v-model.trim="$v.disasterName_ei.$model" type="text" class="input_text"/>
							</div>
              <div class="message">
                <div v-if="$v.disasterName_ei.$dirty">
                  <div class="error" v-if="!$v.disasterName_ei.maxLength">種別(英語)は{{ $v.disasterName_ei.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
						</td>
						<td class="td_mark">
            </td>
					</tr>
					<tr>
						<td class="td_content_bottom">
							<div class="index_name">説明(英語)</div>
							<div>
								<input v-model.trim="$v.description_ei.$model" type="text" class="input_text"/>
							</div>
              <div class="message">
                <div v-if="$v.description_ei.$dirty">
                  <div class="error" v-if="!$v.description_ei.maxLength">説明(英語)は{{ $v.description_ei.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
						</td>
						<td class="td_mark"></td>
					</tr>
				</tbody>
        <!-- 韓国語 -->
				<tbody v-if="languageRadio == 3">
					<tr>
						<td class="td_content_top">
							<div class="index_name">種別(韓国語)</div>
							<div>
								<input v-model.trim="$v.disasterName_kan.$model" type="text" class="input_text"/>
							</div>
              <div class="message">
                <div v-if="$v.disasterName_kan.$dirty">
                  <div class="error" v-if="!$v.disasterName_kan.maxLength">種別(韓国語)は{{ $v.disasterName_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
						</td>
						<td class="td_mark">
            </td>
					</tr>
					<tr>
						<td class="td_content_bottom">
							<div class="index_name">説明(韓国語)</div>
							<div>
								<input v-model.trim="$v.description_kan.$model" type="text" class="input_text"/>
							</div>
              <div class="message">
                <div v-if="$v.description_kan.$dirty">
                  <div class="error" v-if="!$v.description_kan.maxLength">説明(韓国語)は{{ $v.description_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
						</td>
						<td class="td_mark"></td>
					</tr>
				</tbody>
        <!-- 中国語:繁体字 -->
				<tbody v-if="languageRadio == 4">
					<tr>
						<td class="td_content_top">
							<div class="index_name">種別(中国語:繁体字)</div>
							<div>
								<input v-model.trim="$v.disasterName_chu_han.$model" type="text" class="input_text"/>
							</div>
              <div class="message">
                <div v-if="$v.disasterName_chu_han.$dirty">
                  <div class="error" v-if="!$v.disasterName_chu_han.maxLength">種別(中国語:繁体字)は{{ $v.disasterName_chu_han.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
						</td>
						<td class="td_mark">
            </td>
					</tr>
					<tr>
						<td class="td_content_bottom">
							<div class="index_name">説明(中国語:繁体字)</div>
							<div>
								<input v-model.trim="$v.description_chu_han.$model" type="text" class="input_text"/>
							</div>
              <div class="message">
                <div v-if="$v.description_chu_han.$dirty">
                  <div class="error" v-if="!$v.description_chu_han.maxLength">説明(中国語:繁体字)は{{ $v.description_chu_han.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
						</td>
						<td class="td_mark"></td>
					</tr>
				</tbody>
        <!-- 中国語:簡体字 -->
				<tbody v-if="languageRadio == 5">
					<tr>
						<td class="td_content_top">
							<div class="index_name">種別(中国語:簡体字)</div>
							<div>
								<input v-model.trim="$v.disasterName_chu_kan.$model" type="text" class="input_text"/>
							</div>
              <div class="message">
                <div v-if="$v.disasterName_chu_kan.$dirty">
                  <div class="error" v-if="!$v.disasterName_chu_kan.maxLength">種別(中国語:繁体字)は{{ $v.disasterName_chu_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
						</td>
						<td class="td_mark">
            </td>
					</tr>
					<tr>
						<td class="td_content_bottom">
							<div class="index_name">説明(中国語:簡体字)</div>
							<div>
								<input v-model.trim="$v.description_chu_kan.$model" type="text" class="input_text"/>
							</div>
              <div class="message">
                <div v-if="$v.description_chu_kan.$dirty">
                  <div class="error" v-if="!$v.description_chu_kan.maxLength">説明(中国語:繁体字)は{{ $v.description_chu_kan.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
						</td>
						<td class="td_mark"></td>
					</tr>
				</tbody>
			</table>
			<br/>
			<br/>
			<table v-if="languageRadio == 1 || languageRadio == ''">
				<thead>
					<tr>
						<th class="th_area_check">
							<input type="checkbox" v-model="isAllSelected" class="check_area">
						</th>
						<th class="th_area_name">地域名</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="area in areas" v-bind:key="area.id">
						<td>
              <input type="checkbox" v-bind:value=area.area_id v-model="selectedAreas" class="check_area">
            </td>
						<td class="td_area_name">{{ area.area_name }}</td>
					</tr>
				</tbody>
			</table>
			<br v-if="languageRadio == 1 || languageRadio == ''"/>
      <br v-if="languageRadio == 1 || languageRadio == ''"/>
      <div class="page_header_template">マイ・タイムライン テンプレート</div>
			<table>
				<thead>
					<tr>
						<th class="th_event_name">セクション名</th>
						<th class="th_event_task">タスク</th>
						<th class="th_delete"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(template, index) in templates" v-bind:key="template.id">
            <!-- ja -->
            <template v-if="languageRadio == 1 
                            && (template.language_kind == 1 || template.language_kind == null)">
              <td class="td_event_name">
                <div v-if="template.day_offset == 0 && template.hour_offset == 0">
                  <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害発生予想時刻</router-link>
                </div>
                <div v-else-if="template.day_offset == 0 && template.hour_offset != null">
                  <div v-if="template.hour_offset > 0">
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{template.hour_offset}}時間後</router-link>
                  </div>
                  <div v-else>
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{-template.hour_offset}}時間前</router-link>
                  </div>
                </div>
                <div v-else-if="template.day_offset != null">
                  <div v-if="template.day_offset > 0">
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{template.day_offset}}日後</router-link>
                  </div>
                  <div v-else>
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{-template.day_offset}}日前</router-link>
                  </div>
                </div>
              </td>
              <td class="td_event_task">{{ template.events.length }}件</td>
              <td class="td_delete">
                <button class="btn_delete" v-on:click="templateDel(index)">X</button>
              </td>
            </template>
            <!-- en -->
            <template v-else-if="languageRadio == 2 && template.language_kind == 2">
              <td class="td_event_name">
                <div v-if="template.day_offset == 0 && template.hour_offset == 0">
                  <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害発生予想時刻</router-link>
                </div>
                <div v-else-if="template.day_offset == 0 && template.hour_offset != null">
                  <div v-if="template.hour_offset > 0">
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{template.hour_offset}}時間後</router-link>
                  </div>
                  <div v-else>
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{-template.hour_offset}}時間前</router-link>
                  </div>
                </div>
                <div v-else-if="template.day_offset != null">
                  <div v-if="template.day_offset > 0">
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{template.day_offset}}日後</router-link>
                  </div>
                  <div v-else>
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{-template.day_offset}}日前</router-link>
                  </div>
                </div>
              </td>
              <td class="td_event_task">{{ template.events.length }}件</td>
              <td class="td_delete">
                <button class="btn_delete" v-on:click="templateDel(index)">X</button>
              </td>
            </template>
            <!-- 韓国 -->
            <template v-else-if="languageRadio == 3 && template.language_kind == 3">
              <td class="td_event_name">
                <div v-if="template.day_offset == 0 && template.hour_offset == 0">
                  <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害発生予想時刻</router-link>
                </div>
                <div v-else-if="template.day_offset == 0 && template.hour_offset != null">
                  <div v-if="template.hour_offset > 0">
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{template.hour_offset}}時間後</router-link>
                  </div>
                  <div v-else>
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{-template.hour_offset}}時間前</router-link>
                  </div>
                </div>
                <div v-else-if="template.day_offset != null">
                  <div v-if="template.day_offset > 0">
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{template.day_offset}}日後</router-link>
                  </div>
                  <div v-else>
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{-template.day_offset}}日前</router-link>
                  </div>
                </div>
              </td>
              <td class="td_event_task">{{ template.events.length }}件</td>
              <td class="td_delete">
                <button class="btn_delete" v-on:click="templateDel(index)">X</button>
              </td>
            </template>
            <!-- 中国:繁体字 -->
            <template v-else-if="languageRadio == 4 && template.language_kind == 4">
              <td class="td_event_name">
                <div v-if="template.day_offset == 0 && template.hour_offset == 0">
                  <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害発生予想時刻</router-link>
                </div>
                <div v-else-if="template.day_offset == 0 && template.hour_offset != null">
                  <div v-if="template.hour_offset > 0">
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{template.hour_offset}}時間後</router-link>
                  </div>
                  <div v-else>
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{-template.hour_offset}}時間前</router-link>
                  </div>
                </div>
                <div v-else-if="template.day_offset != null">
                  <div v-if="template.day_offset > 0">
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{template.day_offset}}日後</router-link>
                  </div>
                  <div v-else>
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{-template.day_offset}}日前</router-link>
                  </div>
                </div>
              </td>
              <td class="td_event_task">{{ template.events.length }}件</td>
              <td class="td_delete">
                <button class="btn_delete" v-on:click="templateDel(index)">X</button>
              </td>
            </template>
            <!-- 中国:簡体字 -->
            <template v-else-if="languageRadio == 5 && template.language_kind == 5">
              <td class="td_event_name">
                <div v-if="template.day_offset == 0 && template.hour_offset == 0">
                  <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害発生予想時刻</router-link>
                </div>
                <div v-else-if="template.day_offset == 0 && template.hour_offset != null">
                  <div v-if="template.hour_offset > 0">
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{template.hour_offset}}時間後</router-link>
                  </div>
                  <div v-else>
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{-template.hour_offset}}時間前</router-link>
                  </div>
                </div>
                <div v-else-if="template.day_offset != null">
                  <div v-if="template.day_offset > 0">
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{template.day_offset}}日後</router-link>
                  </div>
                  <div v-else>
                    <router-link v-on:click.native="openModalTemplateChange(index)" to="">災害到達の{{-template.day_offset}}日前</router-link>
                  </div>
                </div>
              </td>
              <td class="td_event_task">{{ template.events.length }}件</td>
              <td class="td_delete">
                <button class="btn_delete" v-on:click="templateDel(index)">X</button>
              </td>
            </template>
					</tr>
					<tr>
						<td colspan="3" class="d_event_add">
							<button class="btn_template" @click="openModalTemplate()">＋</button>
						</td>
					</tr>
				</tbody>
			</table>
      <!-- 以下モーダルウィンドウ - テンプレート追加 -->
      <modalTemplate v-if="showModalTemplate" @close="closeModalTemplate">
        <div class="modal_main">
          <table class="tbl_modal_template">
            <thead>
              <tr>
                <th class="th_modal_title">
                  <div>
                    <span>マイ・タイムライン テンプレートの追加</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <div class="modal_template">
                  <label class="modal_template_day">タスクを実行するタイミング</label>
                  <br>
                  <label class="modal_template_day_description">半角数字を入力してください</label>
                  <label class="modal_block">
                    <input type="text" v-model.trim="$v.offsetNum.$model" class="modal_offset_num"/>
                    <select class="modal_task_pull" v-model="offsetDayHour">
                      <option value="0">日</option>
                      <option value="1">時間</option>
                    </select>
                    <select v-if="offsetNum != 0" class="modal_task_pull" v-model="offsetBeforeAfter">
                      <option value="0">前</option>
                      <option value="1">後</option>
                    </select>
                  </label>
                  <div class="message">
                    <div v-if="$v.offsetNum.$dirty">
                      <div class="error" v-if="!$v.offsetNum.required">日付は必須入力です。</div>
                      <div class="error" v-if="!$v.offsetNum.numeric">数値を入力してください。</div>
                      <!-- <div class="error" v-if="!$v.offsetNum.maxLength">{{ $v.offsetNum.$params.maxLength.max }}桁以内で入力してください。</div> -->
                    </div>
                      <div class="error" v-if="!$v.offsetNum.between && offsetDayHour == 0">1〜10の数値を入力してください。</div>
                      <div class="error" v-if="!$v.offsetNum.between && offsetDayHour == 1">0〜23の数値を入力してください。</div>
                  </div>
                </div>
              </tr>
              <tr>
                <div class="modal_task">
                  <table class="tbl_modal_event">
                    <thead>
                      <tr>
                        <th class="th_modal" colspan="2">タスク</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(event, index) in $v.events.$each.$iter" v-bind:key="event.sort_no">
                        <td class="td_modal_event">
                          <input type="text" class="modal_event_input" v-model="event.event.$model">
                          <div v-if="event.event.$dirty">
                            <div class="error" v-if="!event.event.maxLength">タスクは{{ event.event.$params.maxLength.max }}桁以内で入力してください。</div>
                          </div>
                        </td>
                        <td class="modal_btn_delete">
                          <button class="btn_delete" v-on:click="eventDel(index)">X</button>
                        </td>
                      </tr>
                      <tr>
                        <td class="td_modal" colspan="2">
                          <input type="text" v-model.trim="$v.eventName.$model" class="modal_event_input"/>
                        </td>
                      </tr>
                      <tr>
                        <td class="td_modal" colspan="2">
                          <button :disabled="$v.eventName.$invalid" class="modal_btn_plus" @click="taskAdd">＋</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="message">
                    <div v-if="$v.eventName.$dirty">
                      <div class="error" v-if="!$v.eventName.required"></div>
                      <div class="error" v-if="!$v.eventName.maxLength">タスクは{{ $v.eventName.$params.maxLength.max }}桁以内で入力してください。</div>
                    </div>
                  </div>
                </div>
              </tr>
              <tr>
                <div class="modal_event_btn">
                  <div></div>
                  <div>
                    <button :disabled="$v.offsetNum.$invalid 
                                      || !$v.eventName.maxLength 
                                      || $v.events.$each.$invalid 
                                      || (!$v.eventName.required && eventsReactive.length === 0)" 
                                      v-if="changeEventFlg" class="btn_general" @click="templateChange(languageRadio)">更新</button>
                    <button :disabled="$v.offsetNum.$invalid 
                                      || !$v.eventName.maxLength 
                                      || $v.events.$each.$invalid 
                                      || (!$v.eventName.required && eventsReactive.length === 0)" 
                                      v-else class="btn_general" @click="templateChange(languageRadio)">追加</button>
                    <button class="btn_general" @click="closeModalTemplate">キャンセル</button>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modalTemplate>
      <!-- ここまでモーダルウィンドウ - テンプレート追加 -->
      <!-- 以下モーダルウィンドウ - カラー選択 -->
      <modalColor v-if="showModalColor" @close="closeModalColor">
        <div class="modal_main">
          <table class="tbl_modal_color">
            <thead>
              <tr>
                <th class="th_modal_color_title">
                  <span>色の選択</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="color_list">
                <div class="color_outer" v-for="color in colors" v-bind:key="color.color">
                  <div class="color_inner" v-bind:style="{backgroundColor: 'rgb('+color.color+')'}">
                    <a @click="setColor(color.color, color.css)"></a>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modalColor>
      <!-- ここまでモーダルウィンドウ - カラー選択 -->
		</div>
	</div>
</template>

<script>
import modalTemplate from '@/components/DisasterTypeModal'
import modalColor from '@/components/DisasterTypeColorModal'
import { required, maxLength, numeric, between } from 'vuelidate/lib/validators'

export default {
  components: { 
    modalTemplate, 
    modalColor
  },
	data: function() {
		return {
      disasterName: "",
      disasterName_ei: "",
      disasterName_kan: "",
      disasterName_chu_han: "",
      disasterName_chu_kan: "",
      description: "",
      description_ei: "",
      description_kan: "",
      description_chu_han: "",
      description_chu_kan: "",
      markColor: "",
      // 地域情報
      areas: null,
      areasAll: [],
      selectedAreas: [],
      // テンプレート
      templates: [],
      changeTempIndex: null,
      // 以下モーダル変数
      showModalTemplate: false,
      showModalColor: false,
      offsetNum: "",
      offsetDayHour: "",
      offsetBeforeAfter: "",
      eventName: "",
      events: [],
      templateDic: {},
      // イベント変更フラグ
      changeEventFlg: false,
      // 変更フラグ
      changeFlg: false,
      // 色
      colors: [
        { color: '50,50,50' },
        { color: '210,50,50' },
        { color: '220,30,90' },
        { color: '140,32,128' },
        { color: '128,48,180' },
        { color: '48,100,128' },
        { color: '32,80,200' },
        { color: '32,160,96' },
        { color: '120,120,32' },
        { color: '220,128,48' },
        { color: '255,96,0' },
        { color: '240,96,128' },
        { color: '180,160,0' },
        { color: '240,210,0' },
        { color: '32,210,32' },
        { color: '0,152,220' },
        { color: '0,32,144' },
        { color: '0,68,16' },
        { color: '144,0,0' },
        { color: '112,112,112' }
      ],
      languageRadio: 1,
      // メッセージ
      message: "",
      updating: false,
		}
	},
	mounted() {
    // 変更フラグ
    this.changeFlg = this.$store.getters.getStateChangeFlg
    // 地域取得
    this.getAreaList()
    // 変更の場合は詳細情報取得
    if (this.changeFlg) {
      this.getDisasterTypeDetail()
    }
	},
	methods: {
    async getAreaList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
          , action_name: "municipality_area_list"
        }
      })
      // 地域情報をセット
      this.areas = response.data
      // チェックボックス全選択用
      for (var i= 0; i< this.areas.length; i++) {
        this.areasAll.push(this.areas[i].area_id)
      }
    },
    async getDisasterTypeDetail() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'disaster/detail', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          disaster_id: this.$store.getters.getStateDisasterId
        }
      })

      this.disasterName = response.data[0].disaster_name
      this.disasterName_ei = response.data[0].disaster_name_ei
      this.disasterName_kan = response.data[0].disaster_name_kan
      this.disasterName_chu_han = response.data[0].disaster_name_chu_han
      this.disasterName_chu_kan = response.data[0].disaster_name_chu_kan
      this.description = response.data[0].description
      this.description_ei = response.data[0].description_ei
      this.description_kan = response.data[0].description_kan
      this.description_chu_han = response.data[0].description_chu_han
      this.description_chu_kan = response.data[0].description_chu_kan
      this.markColor = response.data[0].mark_color
      this.selectedAreas = response.data[0].area_id
      this.templates = response.data[0].templates

    },
    async disasterTypeAdd() {
      if (!this.disasterNameValidation()) {
        return
      }

      this.updating = true;
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'disaster/add', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          disaster_name: this.disasterName,
          disaster_name_ei: this.disasterName_ei,
          disaster_name_kan: this.disasterName_kan,
          disaster_name_chu_han: this.disasterName_chu_han,
          disaster_name_chu_kan: this.disasterName_chu_kan,
          description: this.description,
          description_ei: this.description_ei,
          description_kan: this.description_kan,
          description_chu_han: this.description_chu_han,
          description_chu_kan: this.description_chu_kan,
          mark_color: this.markColor,
          charge_id: this.$store.getters.getStateChargeId,
          selected_areas: this.selectedAreas,
          templates: this.templates
        })
        this.$router.push('/disasterType')
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.updating = false;
    },
    async disasterTypeUpdate() {
      if (!this.disasterNameValidation()) {
        return
      }

      this.updating = true;
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'disaster/update', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          disaster_id: this.$store.getters.getStateDisasterId,
          disaster_name: this.disasterName,
          disaster_name_ei: this.disasterName_ei == null ? "" : this.disasterName_ei,
          disaster_name_kan: this.disasterName_kan == null ? "" : this.disasterName_kan,
          disaster_name_chu_han: this.disasterName_chu_han == null ? "" : this.disasterName_chu_han,
          disaster_name_chu_kan: this.disasterName_chu_kan == null ? "" : this.disasterName_chu_kan,
          description: this.description,
          description_ei: this.description_ei == null ? "" : this.description_ei,
          description_kan: this.description_kan == null ? "" : this.description_kan,
          description_chu_han: this.description_chu_han == null ? "" : this.description_chu_han,
          description_chu_kan: this.description_chu_kan == null ? "" : this.description_chu_kan,
          mark_color: this.markColor,
          charge_id: this.$store.getters.getStateChargeId,
          selected_areas: this.selectedAreas,
          templates: this.templates
        })
        this.$router.push('/disasterType')
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.updating = false;
    },
    openModalTemplate: function() {
      // 変数の初期化
      this.offsetNum = ""
      this.offsetDayHour = "0"
      this.offsetBeforeAfter = "0"
      this.events = []
      this.changeTempIndex = null
      // イベント変更フラグ
      this.changeEventFlg = false
      // モーダル表示
      this.showModalTemplate = true
    },
		openModalTemplateChange: function(index) {
      // 日時プルダウン
      if (this.templates[index].day_offset != 0) {
        this.offsetNum = this.templates[index].day_offset
        this.offsetDayHour = "0" // 日
      } else {
        this.offsetNum = this.templates[index].hour_offset
        this.offsetDayHour = "1" // 時
      }
      // 前後プルダウン
      if (this.offsetNum < 0) { 
        this.offsetBeforeAfter = "0" // 前
        this.offsetNum = Math.abs(this.offsetNum)
      } else {
        this.offsetBeforeAfter = "1" // 後
      }
      // 参照渡しになってしまうのでコピー
      this.events = this.templates[index].events.concat()
      // 編集時、リスト内オブジェクトが参照を保って、書き換えてしまうので、オブジェクト新規作成
      this.events = this.events.map((obj) => {
        return Object.assign({}, obj)
      })
      // イベント変更フラグ - true
      this.changeEventFlg = true
      // 変更対象のindexを設定
      this.changeTempIndex = index
      // モーダル表示
      this.showModalTemplate = true
    },
    closeModalTemplate: function() {
      // validationsモデルオブジェクトをリセット
      this.$v.offsetNum.$reset()
      this.$v.eventName.$reset()
      // 初期化
      this.eventName = "";
      // モーダルを閉じる
      this.showModalTemplate = false
    },
    taskAdd: function() {
      if (this.eventName.trim() !== "") {
        var e_dic = {}
        e_dic.sort_no = this.events.length
        e_dic.event = this.eventName
        this.events.push(e_dic)
      }
      // 初期化
      this.eventName = ""
      // validationsモデルオブジェクトをリセット
      this.$v.eventName.$reset()
    },
    templateChange: function(language_kind) {
      this.taskAdd();
      if (this.events.length > 0) {
        // 「前」が選択された場合、マイナスを付与
        var offset = this.offsetBeforeAfter == 0 ? -this.offsetNum : this.offsetNum;
        // 辞書の作成
        this.templateDic = {}
        if (this.changeEventFlg) {
          this.$set(this.templateDic, 'template_id', this.templates[this.changeTempIndex].template_id)
        } else {
          this.$set(this.templateDic, 'template_id', "")
        }
        this.$set(this.templateDic, 'language_kind', language_kind)
        if (this.offsetDayHour == 0) {
          this.$set(this.templateDic, 'day_offset', offset)
          this.$set(this.templateDic, 'hour_offset', 0)
        } else {
          this.$set(this.templateDic, 'day_offset', 0)
          this.$set(this.templateDic, 'hour_offset', offset)
        }
        this.$set(this.templateDic, 'events', this.events.filter(x => Boolean(x.event)))

        // 変更の場合は置換、新規の場合は追加
        if (this.changeEventFlg) {
          this.templates.splice(this.changeTempIndex, 1, this.templateDic)
        } else {
          this.templates.push(this.templateDic)
        }

        // v-bind:keyが被らないようidを付加
        var replace = []
        for (var i= 0; i< this.templates.length; i++) {
          this.templates[i].id = i;
          replace.push(this.templates[i])
        }
        this.templates = replace

        // ソート
        this.templates = this.$lodash.orderBy(this.templates, ['hour_offset'], ['asc']);
        this.templates = this.$lodash.orderBy(this.templates, ['day_offset'], ['asc']);
      }
      // モーダルを閉じる
      this.closeModalTemplate()
    },
    templateDel: function(index) {
      this.templates.splice(index, 1)
    },
    eventDel: function(index) {
      this.events.splice(index, 1)
    },
    openModalColor: function() {
			this.showModalColor = true
    },
		closeModalColor: function() {
			this.showModalColor = false
    },
    setInitialColor: function(color, css) {
      this.markColor = color
      document.getElementById('color_box').style.backgroundColor = css
      this.showModalColor = false
    },
    setColor: function(color, css) {
      this.markColor = color
      document.getElementById('color_box').style.backgroundColor = css
      this.showModalColor = false
    },
    disasterNameValidation: function() {
      // 他言語で、説明、templateの設定ありで、種別未入力チェック
      if (this.disasterName_ei == "" || this.disasterName_ei == null) {
        if (this.templates.filter(x => x.language_kind == 2).length > 0 || (this.description_ei != "" && this.description_ei != null)) {
          this.message = "種別(英語)未入力"
          console.log("a")

          return false
        }
        console.log("b")
      } 
      if (this.disasterName_kan == "" || this.disasterName_kan == null) {
        if (this.templates.filter(x => x.language_kind == 3).length > 0 || (this.description_kan != "" && this.description_kan != null)) {
          this.message = "種別(韓国語)未入力"

          return false
        }
      }
      if (this.disasterName_chu_han == "" || this.disasterName_chu_han == null) {
        if (this.templates.filter(x => x.language_kind == 4).length > 0 || (this.description_chu_han != "" && this.description_chu_han != null)) {
          console.log("zh-Hant")
          this.message = "種別(中国語:繁体字)未入力"

          return false
        }
      }
      if (this.disasterName_chu_kan == "" || this.disasterName_chu_kan == null) {
        if (this.templates.filter(x => x.language_kind == 5).length > 0 || (this.description_chu_kan != "" && this.description_chu_kan != null)) {
          console.log("zh-Hans")
          this.message = "種別(中国語:簡体字)未入力"

          return false
        }
      }

      this.message = ""

      return true
    }
  },
  computed: {
    isAllSelected: {
      get: function () {
        return this.areas ? this.areas.length == this.selectedAreas.length : false;
      },
      set: function (checked) {
        this.selectedAreas = checked ? this.areasAll : []
      }
    },
    eventsReactive: function() {
      return this.events.filter(x => Boolean(x.event))
    }
  },
  validations() {
    return {
      events: {
        $each: {
          event: {
            maxLength: maxLength(50)
          }
        }
      },
      disasterName: {
        required,
        maxLength: maxLength(50)
      },
      description: {
        maxLength: maxLength(100)
      },
      disasterName_ei: {
        maxLength: maxLength(50)
      },
      description_ei: {
        maxLength: maxLength(100)
      },
      disasterName_kan: {
        maxLength: maxLength(50)
      },
      description_kan: {
        maxLength: maxLength(100)
      },
      disasterName_chu_han: {
        maxLength: maxLength(50)
      },
      description_chu_han: {
        maxLength: maxLength(100)
      },
      disasterName_chu_kan: {
        maxLength: maxLength(50)
      },
      description_chu_kan: {
        maxLength: maxLength(100)
      },
      offsetNum: {
        required,
        numeric,
        // maxLength: maxLength(2),
        between: this.offsetDayHour == 0 ? between(1, 10) : between(0, 23)
      },
      eventName: {
        required,
        maxLength: maxLength(50)
      }
    }
  }
}
</script>

<style scoped>
.area_radios_div {
  display: flex;
  margin: 0 0 0 30px;
}
.area_radio_div {
  margin: 0 10px 0 0;
  font-size: smaller;
}
.form-check-input {
  margin-left: -1.1rem;
}
.area_radio_label {
  margin: 2px 0 0 0;
}
/* 登録内容 */
table tr {
  border: none;
}
table th.th_regist {
  text-align: left;
  padding-left: 10px;
}
table td.td_content_top {
  width: 680px;
  text-align: left;
  border: none;
  padding: 20px 0px 0px 20px;
}
table td.td_content_bottom {
  width: 680px;
  text-align: left;
  border: none;
  padding: 0px 0px 0px 20px;
}
.index_name {
  padding: 0px 0px 5px 0px;
}
.input_text {
  width: 670px;
}
.td_mark {
  border: none;
}

/* 地域一覧 */
table th.th_area_check {
  width: 30px;
  text-align: center;
}
table th.th_area_name {
  width: 770px;
  text-align: left;
  padding-left: 10px;
}
table td.td_area_name {
  text-align: left;
  padding-left: 10px;
}
.check_area {
	vertical-align: middle;
}

/* テンプレート一覧 */
.page_header_template {
  padding-bottom: 7px;
  text-align: left;
  font-size: 14px;
}
table th.th_event_name {
  text-align: left;
  padding-left: 10px;
  width: 670px;
}
table th.th_event_task {
  text-align: center;
  width: 100px;
}
table th.th_delete {
  width: 30px;
}
table td.td_event_name {
  text-align: left;
  padding-left: 10px;
}
table td.td_event_task {
  text-align: center;
}
table td.td_delete {
  text-align: center;
}
.btn_template {
	background-color: transparent;
	border: none;
	cursor: pointer;
	outline: none;
	padding: 0;
	appearance: none;
}

/* モーダル画面 テンプレートの追加*/
.modal_template {
  text-align: left;
  padding: 20px 20px 5px 20px;
}
.modal_template input {
  vertical-align: middle;
}
.modal_template_day {
  font-size: 13px;
}
.modal_template_day_description {
  font-size: 10px;
  margin-bottom: 0;
}
.modal_block {
  display: block;
}
.modal_task {
  padding: 0px 20px 0px 20px;
}
.modal_offset_num {
  width: 60px;
  height: 25px;
  margin-right: 5px;
}
.modal_task_pull {
  width: 60px;
  height: 25px;
  margin-right: 5px;
  vertical-align: middle;
}
.modal_btn_delete {
  text-align: center;
  width: 30px;
  border-left-style: none; 
}
.tbl_modal_template {
  width: 480px;
  border-collapse: collapse;
  margin: 0 auto;
}
.tbl_modal_event {
  width: 440px;
  border-collapse: collapse;
  margin: 0 auto;
}
table th.th_modal_title {
  font-weight: normal;
  text-align: left;
  padding: 5px 5px 5px 10px;
}
table th.th_modal {
  font-weight: normal;
  text-align: left;
  padding-left: 10px;
}
td.td_modal {
  height: 25px;
}
td.td_message {
  border: none;
}
.modal_btn_add {
  background-color: #ffffff;
  margin-left: 5px;
}
.modal_btn_plus {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
}
.td_modal_event {
  text-align: left;
  padding-left: 10px;
  border-right-style: none;
  height: 25px;
}
.modal_event_input {
  width: 100%;
}
.modal_event_btn {
  display: flex;
  justify-content: space-between;
  border-top: 1px #666666 solid;
  background-color: #F7F2E0;
  padding: 3px 5px 3px 0px;
}
.mark_outer {
  display: table;
  margin: 0 auto;
}
.mark_inner {
  background-color: rgb(192,192,192);
  width: 45px;
  height: 45px;
  text-align: center;
  font-size: 12px;
  font-family: Arial;
  display: table-cell;
  vertical-align: middle;
  border-radius: 7px 7px 7px 7px;
  color: #F4F4F4;
}
.btn_general {
  margin-left: 5px;
}

/* モーダル 色選択画面 */
table.tbl_modal_color {
  border-collapse: collapse;
  margin: 0 auto;
}
table.tbl_modal_color td a {
  display: block;
  width: 100%;
  height: 100%;
  font-size: 1px;
}
table.tbl_modal_color .td_color {
  color: transparent;
}
.color_list {
  width: 200px;
  display: flex;
  flex-wrap: wrap
}
.color_outer {
  position: relative;
}
.color_outer a {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.color_inner {
  height: 40px;
  width: 40px;
  color: transparent;
}
</style>